import { TFunction } from 'i18next'
import { ChargingSessionModel } from '../models/charging-sessions.model'

interface Params {
  wallbox: {
    id: ChargingSessionModel['wallbox']['id']
    name: ChargingSessionModel['wallbox']['name']
  }
  showId: boolean
}

/**
 * To populate wallbox filter dropdown, we generate a proper dropdown option label.
 *
 * - In case wallbox name is not set up, we display just the wallbox id.
 *
 * - In case wallbox name is set up and multiple wallboxes connected to the installation share
 *   the same name, we display both wallbox name and id.
 *
 * - In case wallbox name is set up and wallbox name is unique among connected wallboxes, we
 *   display just the wallbox name.
 */
export const formatWallboxLabel = ({ wallbox, showId }: Params, t: TFunction): string => {
  const { id, name } = wallbox

  if (id && name && showId) {
    return t('emobility.chargingSession.wallbox-name-and-id', { name, id })
  }

  if (id && name) {
    return name
  }

  return t('emobility.chargingSession.wallbox-id', { id })
}
